module.exports = __webpack_public_path__ + "20250721160708/img/data.3138f70b.png";